export function themeMenu() {
  const menuIcon = document.querySelector('.menu-toggle');

  menuIcon.addEventListener('click', function() {

    let menuIconState = this.getAttribute('aria-expanded');
    let menu          = document.querySelector('.nav-expanded');
    let menuState     = menu.getAttribute('data-status');

    if( menuIconState === 'true' ) {
      menuIconState = 'false';
      menuState = 'closed';
    } else {
      menuIconState = 'true';
      menuState = 'open';
    }

    this.setAttribute('aria-expanded', menuIconState);
    menu.setAttribute('data-status', menuState);

    document.body.classList.toggle('menu-open');
  })
}
